export const premiumWhiteCardStyle = {
  background: 'var(--surface)',
  border: '1px solid var(--card-border)',
  boxShadow: 'var(--premium-shadow-main)',
  borderRadius: 28,
};

export const premiumBubbleStyle = {
  background: 'var(--surface)',
  border: '1px solid var(--card-border)',
  boxShadow: 'var(--premium-shadow-main)',
  borderRadius: 22,
};
